import React from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import Link from './Link';

const Tab = ({ tab, current }) => (
  <Link
    className={clsx(
      `p-0 m-0 border-b-2 transition-colors focus:outline-none focus:border-chocolate-600 ring-0 font-medium hover:text-chocolate-1000`,
      {
        'border-chocolate-600 !text-chocolate-600': current,
        'border-transparent': !current,
      },
    )}
    href={tab.href}
    aria-current={current ? 'page' : undefined}
  >
    {tab.name}
  </Link>
);

const Container = ({ children, tabs }) => {
  const location = useLocation();
  const currentTab = tabs.find(tab => location.pathname === tab.href) || {};

  return (
    <div className="w-full md:w-auto flex mt-auto overflow-hidden">
      <nav className="flex gap-x-4 order-2 lg:order-1 overflow-x-auto whitespace-nowrap min-w-0">
        {children({ currentTab })}
      </nav>
    </div>
  );
};

const CardHeaderNav = {
  Container,
  Tab,
};

export default CardHeaderNav;
